export default __webpack_public_path__ + "static/media/battery-status.4843e10a.svg";